export default "__VITE_ASSET__63e49ee4__"